import { call } from '../core'
import { HostType } from './requestPinAuth'

export interface IRequestAuthParams {
  hostType: HostType
  apiUrl: string
  header?: string // JSON string
  request: string // JSON string
}

export interface IRequestAuthInfo {
  isSuccess: boolean
  response: string // JSON string
}

export interface IRequestAuthResult {
  result: IRequestAuthInfo | null
}

export function requestAuth(params: IRequestAuthParams): Promise<IRequestAuthResult | Error> {
  return call('finRequestAuth', params)
}
